import { Env } from '@core/interfaces/env';

export const environment: Env = {
  production: false,
  stage: 'qas',
  app: {
    name: 'Programa de referidores de Inversiones.io',
    host: 'https://referidores.inversiones.io',
    shortName: 'GpInversiones.io',
    subName: 'Referidores',
    version: '1.0.0',
    logo: 'logo.png',
    logoIco: 'logo.png',
  },
  api: { baseUrl: 'http://localhost:3000/api' },
  paginator: {
    rowsPerPageOptions: [10, 25, 50],
    defaultLimit: 10,
  },
  ioCoins: {
    name: 'IO COINS',
  },
};
